<div class="container-fluid py-4">
  <div class="row justify-content-center">
    <div class="col-3 col-md-2" *ngFor="let card of resumenCards; index as i">
      <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 1 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 1, 'text-white': i !== 1 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 1 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Campo de búsqueda mejorado con autocompletado -->
  <div class="row mb-3">
    <div class="col-md-4">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          placeholder="Search ..."
          [(ngModel)]="searchText"
          (ngModelChange)="filterInfo()"
          list="suggestions"
          autocomplete="off"
        />
        <span class="input-group-text bg-transparent"
          ><i class="fas fa-search text-dark"></i
        ></span>
        <datalist id="suggestions">
          <option
            *ngFor="let sugerencia of sugerenciasBusqueda"
            [value]="sugerencia"
          ></option>
        </datalist>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-header text-center">
      <div class="card-tools">
        <a
          [ngClass]="{
          btn: true,
          'btn-sm': true,
          'btn-dark': true,
          'btn-new': step !== 1,
          'btn-new__selected': step === 1,
        }"
          (click)="changeStep(1)"
        >
          Onboarding
        </a>
        <a
          [ngClass]="{
          btn: true,
          'btn-sm': true,
          'btn-dark': true,
          'btn-new': step !== 2,
          'btn-new__selected': step === 2,
        }"
          (click)="changeStep(2)"
        >
          Training
        </a>
        <a
          [ngClass]="{
          btn: true,
          'btn-sm': true,
          'btn-dark': true,
          'btn-new': step !== 3,
          'btn-new__selected': step === 3,
        }"
          (click)="changeStep(3)"
        >
          Evaluation
        </a>
        <a
          [ngClass]="{
          btn: true,
          'btn-sm': true,
          'btn-dark': true,
          'btn-new': step !== 4,
          'btn-new__selected': step === 4,
        }"
          (click)="changeStep(4)"
        >
          NDA & Legal
        </a>
        <a
          [ngClass]="{
          btn: true,
          'btn-sm': true,
          'btn-dark': true,
          'btn-new': step !== 5,
          'btn-new__selected': step === 5,
        }"
          (click)="changeStep(5)"
        >
          Requests
        </a>
      </div>
    </div>
    <div class="card-body" *ngIf="step == 4">
      <div class="card-tools text-center">
        <a
          [ngClass]="{
          btn: true,
          'btn-sm': true,
          'btn-dark': true,
          'btn-new': stepUser !== 1,
          'btn-new__selected': stepUser === 1,
        }"
          (click)="changeStepUser(1)"
        >
          Visitor User
        </a>
        <a
          [ngClass]="{
          btn: true,
          'btn-sm': true,
          'btn-dark': true,
          'btn-new': stepUser !== 2,
          'btn-new__selected': stepUser === 2,
        }"
          (click)="changeStepUser(2)"
        >
          In-House User
        </a>
      </div>
    </div>

    <div class="card-body" *ngIf="stepUser == 1 && step == 4">
      <div class="card-tools text-center">
        <!-- <a
          class="a__inHouseOrVisitor"
          [href]=""
          target="_blank"
          rel="noopener noreferrer"
          >Profile</a
        >
        <a
          class="a__inHouseOrVisitor"
          [href]=""
          target="_blank"
          rel="noopener noreferrer"
          >Compliance
        </a>
        <a
          class="a__inHouseOrVisitor"
          [href]="ndaEng"
          target="_blank"
          rel="noopener noreferrer"
          >NDA English
        </a>
        <a
          class="a__inHouseOrVisitor"
          [href]="ndaEsp"
          target="_blank"
          rel="noopener noreferrer"
          >NDA Spanish</a
        >
        <a
          class="a__inHouseOrVisitor"
          [href]="teamAccess"
          target="_blank"
          rel="noopener noreferrer"
          >Security & Access</a
        > -->
        <a class="a__inHouseOrVisitor" target="_blank" [href]="downloadVisitorFiles">
          Download files
        </a>
      </div>
    </div>

    <div class="card-body" *ngIf="stepUser == 2 && step == 4">
      <div class="card-tools text-center">
        <!-- <a
          class="a__inHouseOrVisitor"
          [href]=""
          target="_blank"
          rel="noopener noreferrer"
          >Profile</a
        >
        <a
          class="a__inHouseOrVisitor"
          [href]=""
          target="_blank"
          rel="noopener noreferrer"
          >Compliance
        </a>
        <a
          class="a__inHouseOrVisitor"
          [href]="ndaEng"
          target="_blank"
          rel="noopener noreferrer"
          >NDA English
        </a>
        <a
          class="a__inHouseOrVisitor"
          [href]="ndaEsp"
          target="_blank"
          rel="noopener noreferrer"
          >NDA Spanish</a
        >
        <a
          class="a__inHouseOrVisitor"
          [href]="teamAccess"
          target="_blank"
          rel="noopener noreferrer"
          >Security & Access</a
        > -->
        <a class="a__inHouseOrVisitor" target="_blank" [href]="downloadInHouseFiles">
          Download files
        </a>
      </div>
    </div>

    <div class="card-body" *ngIf="step == 6">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <!--  <th>Employee Name</th>
                <th>Role</th>
                <th>Department</th>
                <th>Status</th>
                <th>Actions</th> -->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredData">
              <!-- <td>
                <a
                  [routerLink]="['/humanResouerces/personnel/edit', item._id]"
                  class="btn btn-link btn-sm p-2 a--personnel"
                >
                  {{ item.user.firstname }} {{ item.user.lastname }}</a
                >
              </td>
              <td>{{ item.user.role?.name || "" }}</td>
              <td>{{ item.user.department }}</td>
              <td>
                <span
                  class="badge"
                  [ngClass]="
                    item.user.status ? 'badge-success' : 'badge-danger'
                  "
                >
                  {{ item.status ? "Active" : "Inactive" }}
                </span>
              </td>
              <td>
                <a
                  [routerLink]="['/humanResouerces/personnel/edit', item._id]"
                  class="btn btn-link text-dark btn-sm btn-del"
                >
                  <i class="fas fa-edit"></i>
                </a>
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
